// extracted by mini-css-extract-plugin
export default {"uploadButton":"AttachmentList-module_uploadButton__ZWmON"};